import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { MatDialogModule, MatProgressSpinnerModule, MatFormFieldModule, MatInputModule, MatDatepickerModule, MatDividerModule, MatStepperModule, MatRadioModule, MatSelectModule, MatTableModule, MatCheckboxModule, MatMenuModule, MatCardModule } from '@angular/material';
import { SnackSuccessComponent } from './components/snack-success/snack-success.component';
import { SnackErrorComponent } from './components/snack-error/snack-error.component';
import { SnackWaitComponent } from './components/snack-wait/snack-wait.component';
import { QuitConfirmDialogComponent } from './components/quit-confirm-dialog/quit-confirm-dialog.component';
import { FileUploadModule } from 'ng2-file-upload';
import { WarningDialogComponent } from './components/warning-dialog/warning-dialog.component';
import { InfoDialogComponent } from './components/info-dialog/info-dialog.component';
import { FormsModule } from "@angular/forms";
import { ReactiveFormsModule } from "@angular/forms";
import { TextFieldModule } from "@angular/cdk/text-field";
import { MatTooltipModule } from "@angular/material/tooltip";
import { ErrorDialogComponent } from "src/app/shared/components/error-dialog/error-dialog.component";
import { RecaptchaModule } from 'ng-recaptcha';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { PipesModuleModule } from "src/app/pipes/pipes-module.module";
import { DirectivesModule } from "src/app/directives/directives.module";
import { MonthDateSimuComponent } from "src/app/shared/components/month-date-simu/month-date-simu.component";
import { MonthDateComponent } from "src/app/shared/components/month-date/month-date.component";
import { DecimalEuroPipe } from "src/app/pipes/decimal-euro.pipe";
import { PrefixTelComponent } from './components/prefix-tel/prefix-tel.component';
import { ContactDialogComponent } from "src/app/shared/components/contact-dialog/contactDialog.component";
import { ProtectionDonneesComponent } from 'src/app/shared/components/protectionDonnees/protectionDonnees.component';
import { CguComponent } from 'src/app/shared/components/cg/cgu.component';
import { AccesibiliteComponent } from './components/accessibilite/accessibilite.component';
import { PlanActionComponent } from './components/plan-action/plan-action.component';

@NgModule( {
    providers: [
        DecimalEuroPipe
    ],
    imports: [ 
        CommonModule,
        MatIconModule,
        MatButtonModule,
        MatTooltipModule,
        MatProgressSpinnerModule,
        FormsModule,
        ReactiveFormsModule,
        TextFieldModule,
        MatExpansionModule,
        MatAutocompleteModule,
        MatSelectModule,
        MatInputModule,
        MatCheckboxModule,
        MatRadioModule,
        MatStepperModule,
        RecaptchaModule,
        MatFormFieldModule,
        MatDatepickerModule,
        FlexLayoutModule,
        MatDialogModule,
        DirectivesModule,
        MatTableModule,
        FileUploadModule,
        MatCardModule,
        PipesModuleModule, MatDividerModule, PipesModuleModule, MatMenuModule
    ],
    declarations: [PlanActionComponent, MonthDateComponent, MonthDateSimuComponent, ConfirmDialogComponent, SnackSuccessComponent, SnackErrorComponent, SnackWaitComponent, QuitConfirmDialogComponent, WarningDialogComponent, InfoDialogComponent, ErrorDialogComponent, PrefixTelComponent, ContactDialogComponent, ProtectionDonneesComponent, CguComponent, AccesibiliteComponent],
    exports: [AccesibiliteComponent, PlanActionComponent, MonthDateComponent, MonthDateSimuComponent, MonthDateSimuComponent, PrefixTelComponent, ContactDialogComponent],
    entryComponents: [ContactDialogComponent, ProtectionDonneesComponent, CguComponent]
} )
export class SharedModule {
}
